import React from 'react'
import { useTranslation } from 'react-i18next'
import { CARD } from './ChatStatsSection'
import { formatNumber } from './chatStatsFormat'

const initialsOf = (name) =>
    (name || '')
        .split(' ')
        .filter(Boolean)
        .map((part) => part[0].toUpperCase())
        .slice(0, 2)
        .join('') || '?'

function ChatStatsAttention({ stats }) {
    const { t } = useTranslation()
    const { awaiting, overdue, staff } = stats.attention
    const hasOverdue = overdue > 0

    return (
        <div style={{ ...CARD, padding: '22px 24px', flex: 1, minWidth: 320 }}>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#2d2b45', marginBottom: 16 }}>{t('chatStatsNeedsAttention')}</div>

            <div style={{ display: 'flex', gap: 14, marginBottom: 18 }}>
                <div style={{ flex: 1, background: '#f5f3fa', borderRadius: 14, padding: '15px 16px' }}>
                    <div style={{ fontSize: 30, fontWeight: 800, color: '#2d2b45', lineHeight: 1 }}>{formatNumber(awaiting)}</div>
                    <div style={{ fontSize: 12, color: '#8e8fb4', marginTop: 6, fontWeight: 600 }}>{t('chatStatsAwaiting')}</div>
                </div>
                <div style={{ flex: 1, borderRadius: 14, padding: '15px 16px', background: hasOverdue ? 'rgba(252, 76, 89, 0.08)' : '#f5f3fa' }}>
                    <div style={{ fontSize: 30, fontWeight: 800, color: hasOverdue ? '#fc4c59' : '#2d2b45', lineHeight: 1 }}>{formatNumber(overdue)}</div>
                    <div style={{ fontSize: 12, color: hasOverdue ? '#b21f2b' : '#8e8fb4', marginTop: 6, fontWeight: 700 }}>{t('chatStatsOverdue')}</div>
                </div>
            </div>

            {staff.length === 0 ? (
                <div style={{ fontSize: 13, color: '#8e8fb4' }}>{t('chatStatsNothingWaiting')}</div>
            ) : (
                <>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#2d2b45', marginBottom: 12 }}>{t('chatStatsStaffOutstanding')}</div>
                    {staff.map((person) => (
                        <div key={person.user_id} style={{ display: 'flex', alignItems: 'center', gap: 11, marginBottom: 11 }}>
                            <span
                                style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: 999,
                                    background: '#eeedf6',
                                    color: '#5e639b',
                                    flex: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 12,
                                    fontWeight: 700,
                                }}
                            >
                                {initialsOf(person.name)}
                            </span>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: 13, fontWeight: 600, color: '#5e639b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {person.name || t('chatStatsUnknownUser')}
                                </div>
                                {person.role_label && <div style={{ fontSize: 11, color: '#8e8fb4' }}>{person.role_label}</div>}
                            </div>
                            {person.overdue > 0 && (
                                <span style={{ fontSize: 11, fontWeight: 700, color: '#b21f2b', background: 'rgba(252, 76, 89, 0.1)', padding: '3px 8px', borderRadius: 999 }}>
                                    {t('chatStatsOverdueBadge', { count: person.overdue })}
                                </span>
                            )}
                            <span style={{ fontSize: 15, fontWeight: 800, color: '#2d2b45', width: 24, textAlign: 'right' }}>{person.open}</span>
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}

export default ChatStatsAttention
